import LinkButton from './LinkButton.vue'

export default LinkButton
